import { Link } from 'react-router-dom';
import rebaseLogo from '../assets/rebase-app-icon.png';
import WelcomeBackground from '../components/WelcomeBackground';
import craneImg from '../assets/illustrations/crane.png';

const GREEN = '#18B95B';
const GREEN_DEEP = '#0f8f5f';
const INK = '#1F2A33';

const EnvelopeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

const PersonIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.6-6 8-6s8 2 8 6" />
  </svg>
);

// Hard hat — the "profile" step.
const HelmetIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 18c0-1.4 1.1-2.2 2.5-2.2h11c1.4 0 2.5.8 2.5 2.2 0 1.2-1 2-2.4 2H6.4C5 20 4 19.2 4 18Z" fill={INK} />
    <path d="M6.5 16C6.5 10.5 9 7 12 7s5.5 3.5 5.5 9h-11Z" fill={GREEN} />
    <path d="M11 7h2v9h-2z" fill="#0a5b3d" />
  </svg>
);

// Trade / tools — the "preferences" step.
const ToolsIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke={INK} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14.5 5.5a3.5 3.5 0 0 0 4.6 4.6l-9 9a2.1 2.1 0 0 1-3-3l9-9Z" />
    <path d="m3.5 3.5 4 4M6 6l2.5 2.5" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke={INK} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    <path d="M3 12h18" />
  </svg>
);

const steps = [
  { n: 1, title: 'פרופיל', desc: 'מקצוע, ותק, תעודות והסמכות', Icon: HelmetIcon },
  { n: 2, title: 'העדפות', desc: 'מקצועות, אזור עבודה ומשמרת', Icon: ToolsIcon },
  { n: 3, title: 'משרות', desc: 'התאמות באתרים והגשה מהירה', Icon: BriefcaseIcon },
];

const Welcome = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#f3fbf6]">
      <WelcomeBackground />

      <div className="relative mx-auto flex min-h-screen w-full max-w-md flex-col px-7 pb-7 pt-16 lg:max-w-5xl lg:px-12 lg:pb-12 lg:pt-12">
        <header className="mt-1 flex items-center justify-center gap-3 lg:justify-end">
          <div className="flex flex-col items-end leading-tight">
            <span className="block whitespace-nowrap text-[0.6rem] font-semibold text-[#1F2A33] lg:text-xs">מצאו את עבודת הבנייה הבאה</span>
            <span
              className="mt-1 block w-full text-[1.6rem] font-extrabold leading-none lg:text-[1.6rem]"
              style={{ color: GREEN_DEEP, textAlign: 'justify', textAlignLast: 'justify' }}
            >
              בענף הבנייה
            </span>
          </div>
          <span className="h-11 w-px flex-shrink-0 bg-[#bfe6cd]" />
          <img src={rebaseLogo} alt="Rebase" className="h-11 w-11 flex-shrink-0 lg:h-12 lg:w-12" />
        </header>

        <section className="mx-auto mt-16 max-w-[19rem] text-right lg:mx-0 lg:mt-20 lg:max-w-md">
          <h1 className="text-[1.9rem] font-extrabold leading-tight text-[#1F2A33] lg:text-4xl">בואו נתחיל.</h1>
          <p className="mt-2 text-[1.2rem] font-bold leading-tight lg:text-xl" style={{ color: GREEN_DEEP }}>
            היעד: המשרה הבאה שלכם באתר.
          </p>
          <p className="mt-2 text-sm leading-6 text-[#3E5361] lg:text-base">
            בניית פרופיל מקצועי, בחירת מקצוע ואזור עבודה, וקבלת משרות שמתאימות לכם.
          </p>
        </section>

        <div className="relative mt-auto lg:mt-10">
          <img
            src={craneImg}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute -left-32 bottom-0 w-[68rem] lg:hidden"
          />
          <div className="mx-auto w-full max-w-[12rem] space-y-3 lg:mx-0 lg:flex lg:max-w-none lg:gap-3 lg:space-y-0">
            <Link
              to="/register"
              className="relative flex h-12 items-center justify-center rounded-md text-base font-extrabold text-white shadow-md transition hover:brightness-105 lg:w-40"
              style={{ background: `linear-gradient(180deg, ${GREEN} 0%, ${GREEN_DEEP} 100%)` }}
            >
              <span className="absolute left-5 flex items-center">
                <EnvelopeIcon />
              </span>
              הרשמה
            </Link>
            <Link
              to="/login"
              className="relative flex h-12 items-center justify-center rounded-md border text-base font-extrabold text-[#0f8f5f] shadow-sm transition hover:bg-[#f0faf4] lg:w-40"
              style={{ borderColor: '#8fd1ac', background: 'rgba(255,255,255,0.7)' }}
            >
              <span className="absolute left-5 flex items-center">
                <PersonIcon />
              </span>
              התחברות
            </Link>
          </div>
        </div>

        <section className="mx-5 mt-6 rounded-2xl border border-[#d3edde] bg-white/80 px-5 py-6 shadow-sm backdrop-blur-sm lg:-mx-16 lg:mt-auto lg:px-6 lg:py-5">
          <div className="text-center">
            <h2 className="text-base font-extrabold leading-tight text-[#1F2A33] lg:text-2xl">שלושה צעדים למשרה הבאה</h2>
            <p className="mt-2 text-xs text-[#3E5361] lg:text-base">עדכנו פרטים, קבלו התאמות והגישו מועמדות</p>
          </div>

          <div className="mt-5 divide-y divide-[#e6f7ec] lg:grid lg:grid-cols-3 lg:divide-x lg:divide-y-0 lg:divide-x-reverse">
            {steps.map(({ n, title, desc, Icon }) => (
              <div key={n} className="flex items-center gap-4 py-4 lg:flex-col lg:px-4 lg:py-2">
                <span
                  className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-extrabold text-white shadow-sm lg:h-11 lg:w-11 lg:text-lg"
                  style={{ background: GREEN }}
                >
                  {n}
                </span>
                <div className="min-w-0 flex-1 text-right lg:text-center">
                  <p className="text-sm font-extrabold text-[#1F2A33] lg:text-lg">{title}</p>
                  <p className="mt-0.5 text-[0.65rem] text-[#3E5361] lg:text-sm">{desc}</p>
                </div>
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-[#e6f7ec]">
                  <Icon />
                </span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Welcome;
